import { Button, Text, VStack } from '@bpba/ui-components';
import { FC } from 'react';
import { WARNING_CONTAINER_ICON_SIZE } from '../constants/dimensions';
import { TIME_RESTRICTION_MESSAGE } from '../constants/data';
import { StyledBox } from '../components/shared/StyledBox';
import { InfoIcon } from '../components/shared/InfoIcon';

type Props = {
  show: boolean;
  onCancel: () => void;
};

/**Componente utilizado para informar que la operación
 * no se puede realizar por encontrarse fuera de horario.
 */
export const TimeRestrictionMessage: FC<Props> = ({ show, onCancel }) => {
  return (
    <VStack display={show ? 'flex' : 'none'}>
      <StyledBox flexDirection={'column'} alignItems="center" tabIndex={0} color="tertiary.0" my={'48px'}>
        <InfoIcon size={WARNING_CONTAINER_ICON_SIZE} />
        <Text fontSize={['14px', '17px']} dangerouslySetInnerHTML={{ __html: TIME_RESTRICTION_MESSAGE }} />
      </StyledBox>
      <StyledBox justifyContent={'end'} mt={'24px'}>
        <Button
          type="button"
          variant="transparent"
          mx={'0px !important'}
          onClick={onCancel}
          px={'24px !important'}
          width={['fit-content !important', '100% !important']}
          maxWidth={['100px', '200px']}
        >
          Volver
        </Button>
      </StyledBox>
    </VStack>
  );
};
